// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__32WFV","inputWrap":"styles_inputWrap__15tN4","input":"styles_input__1D1Az"};